import { render, staticRenderFns } from "./suppliers-footwear-filters.vue?vue&type=template&id=b08f3818"
import script from "./suppliers-footwear-filters.vue?vue&type=script&lang=js"
export * from "./suppliers-footwear-filters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/Resourced/Resourced/Frontend-old/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b08f3818')) {
      api.createRecord('b08f3818', component.options)
    } else {
      api.reload('b08f3818', component.options)
    }
    module.hot.accept("./suppliers-footwear-filters.vue?vue&type=template&id=b08f3818", function () {
      api.rerender('b08f3818', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/pages/suppliers-footwear-filters.vue"
export default component.exports